import React, { useEffect, useState } from "react";
import "./ItemsTable.scss";
import Pagination from "../Pagination/Pagination";
import { FiltersIcon } from "../../assets/icons";
import UnauthorizedImage from "../../assets/images/unauthorized.svg";
import { useThemedAssets } from "../../helpers/themeAssets";

const DEFAULT_PAGE_SIZE_OPTIONS = [10, 50, 100];

function ItemsTable({
  headers,
  data,
  classNames,
  isEditing = false,
  filterValues,
  currentPage,
  recordsPerPage,
  totalRecords,
  onPageChange,
  onRecordsPerPageChange,
  pageSizeOptions = DEFAULT_PAGE_SIZE_OPTIONS,
  callBackSort,
  userCanRead,
}) {
  const {
    cassetteRowClass = "",
    cassetteHeaderClass = "",
    cassetteRowContainerClass = "",
  } = classNames || {};

  const [tableData, setTableData] = useState(data || []);
  const [isSortActive, setSortActive] = useState(false);
  const [isPopupOpen, setPopupOpen] = useState(false);
  const [currentHeaderKey, setCurrentHeaderKey] = useState("");
  const [currentHeaderLid, setCurrentHeaderLid] = useState("");
  const [isHeaderLidPresent, setHeaderLidPresent] = useState(false);
  const { noData: noDataImage } = useThemedAssets();

  useEffect(() => {
    data && setTableData([...data]);
  }, [data]);

  // If no headers or data are available, return null
  

  if(!userCanRead)  {
    return (
      <div className="no-authorization-message">
        <div>
          <img src={UnauthorizedImage} alt="No data" className="no-authorization-message-image" />
          <p className="no-authorization-message-text">Non hai i permessi per visualizzare questa pagina!</p>
        </div>
      </div>
    );
  }

  if (!headers || !data || data.length === 0) {
    return (
      <div className="no-data-message">
        <div>
          <img src={noDataImage} alt="No data" className="no-data-message-image" />
          <p className="no-data-message-text">Non ci sono dati da visualizzare!</p>
        </div>
      </div>
    );
  }

  const handleSort = (key = "") => {
    if (data) {
      callBackSort(key);
    }
    // setTableData([...data]);
  };
  function handlePopUp(headerKey, lidvalue) {
    setPopupOpen(!isPopupOpen);
    setCurrentHeaderKey(headerKey);
    setCurrentHeaderLid(lidvalue);
  }

  function handleClosePopup() {
    setPopupOpen(false);
  }

  return (
    <div className="tbl-container">
      <div className="tbl-scrollable-content">
        <div className="tbl-sub-container">
          <header className="tbl-header">
            {headers?.map((header, index) => (
              <div
                key={index}
                className="tbl-header-item"
                style={{
                  maxWidth: `${header.width}`,
                  minWidth: `${header.width}`,
                }}
              >
                <div className="tbl-header-item-text">{header.label}</div>
                {header.sortable === true && (
                  <div
                    loading="lazy"
                    //src={FiltersIcon}
                    alt=""
                    className="tbl-header-item-icon"
                    style={{ cursor: "pointer" }}
                    onClick={() => handleSort(header?.key)}
                  >
                    <FiltersIcon fillColor="var(--archeo-color)" />
                  </div>
                )}
              </div>
            ))}
          </header>
          {tableData?.map((item, index) => {
            return item[filterValues?.label]?.value === filterValues?.value ? (
              <div key={index} className="tbl-row">
                {isEditing && (
                  <div className="checkbox-wrapper">
                    <div className="checkbox" />
                  </div>
                )}
                {headers?.map((header, headerIndex) => (
                  <div
                    key={`${item.id || index}-${headerIndex}`}
                    className={`tbl-row-item ${header.className || ""}`}
                    style={{
                      maxWidth: `${header.width}`,
                      minWidth: `${header.width}`,
                    }}
                  >
                    {item[header.key]?.component
                      ? item[header.key]?.component
                      : item[header.key]?.value}
                    {header.isGisReference === true && // GIS REFERENCE ONLY
                      item[header.key]?.value !== "" && (
                        <div
                          className="tbl-row-item-icon"
                          onClick={() =>
                            handlePopUp(header.key, item[header.key].value)
                          }
                          style={{ cursor: "pointer" }} // Change cursor to hand pointer
                        >
                          {/*<EyeIcon/> */}
                        </div>
                      )}
                  </div>
                ))}
              </div>
            ) : (
              <></>
            );
          })}
        </div>{" "}
        {/* tbl-sub-container */}
      </div>{" "}
      {/* tbl-scrollable-content */}
      <div className="tbl-fixed-bottom">
        <Pagination
          currentPage={currentPage}
          recordsPerPage={recordsPerPage}
          totalRecords={totalRecords}
          onPageChange={onPageChange}
          onRecordsPerPageChange={onRecordsPerPageChange}
          pageSizeOptions={pageSizeOptions}
        />
      </div>{" "}
      {/* tbl-fixed-bottom */}
    </div>
  );
}

export default ItemsTable;
